/** @format */
'use client';
import useAxios from '@/hooks/useAxios.hook';
import { RootState } from '@/redux/store';
import { endPoint } from '@/utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useTrendingList = () => {
  const [initialState, setInitialState] = useState({
    limit: 10,
    skip: 0,
    refreshing: false,
    data: [],
    hasMore: true,
  });
  const { limit, skip, refreshing, data, hasMore } = initialState;
  const { fetchData, loading } = useAxios();
  const updateState = (newState: any) => {
    setInitialState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };
  const location = useSelector((state: RootState) => state.location);
  const coordinates = [location?.lng, location?.lat];

  const fetchSearchData = async ({
    limit = 10,
    skip,
    loading = true,
  }: {
    limit?: number;
    skip: number;
    loading?: boolean;
  }) => {
    const res = await fetchData({
      url: endPoint.FETCH_TRENDING_EVENTS_BY_PAGE_GUEST_BY_LOCATION,
      params: {
        limit,
        skip,
      },
      method: 'POST',
      data: { queryString: 'live performances', coordinates },
      loading,
    });
    if (hasMore) {
      updateState({
        data: [...data, ...res?.data],
        hasMore: res?.data?.length > limit || res?.data?.length === limit,
      });
    }
  };

  useEffect(() => {
    fetchSearchData({ limit, skip });
  }, [location]);

  return {
    loading,
    data,
    refreshing,
    hasMore,
    skip,
  };
};

export default useTrendingList;
